import { EditOutlined } from "@ant-design/icons"

type EditIconProps = {
    onClick: () => void
}
export const EditIcon: React.FC<EditIconProps> = ({ onClick }) => {
    return <EditOutlined onClick={onClick} />
}